module.exports = __webpack_public_path__ + "static/img/mid.33d106a1.jpg";